import { Component, DestroyRef, inject, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/base/base.component';
import { ColoredTextItem, NamedColorList } from 'src/app/domainObjects/coloredTextItem';
import { NamedColor } from 'src/app/domainObjects/namedColor';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

class ViewModel {
  colors: NamedColor[];
  textItems: ColoredTextItem[] = [];
  currentColor: NamedColor;
  currentValue: string;
  sourceItems: ColoredTextItem[] = [];

  constructor(items: ColoredTextItem[],sourceItems: ColoredTextItem[]) {
    const itemsCopy = items.map(r => new ColoredTextItem(r.text, r.color)) ?? [];
    this.textItems = itemsCopy ?? [];
    this.colors = NamedColorList;

    const maxlength = this.colors.length;
    let nextlength = this.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.currentColor = this.colors[nextIndex];
    const sourceItemsCopy = sourceItems.map(r => new ColoredTextItem(r.text, r.color)) ?? [];
    this.sourceItems = sourceItemsCopy ?? [];
  }
}

@Component({
    selector: 'app-value-entry-field',
    templateUrl: './value-entry-field.component.html',
    styleUrls: ['./value-entry-field.component.css'],
    standalone: false
})
export class ValueEntryFieldComponent extends BaseComponent implements OnInit{
  private readonly destroyRef = inject(DestroyRef);
  title: string="Range Entry";
  symbol: string="=";
  isSpinner: boolean = true;
  isPositiveInteger: boolean = false;
  isShowHeader: boolean = true;
  isAddNew: boolean = true;
  enterKeyPressCount: number = 0;  // Counter for Enter key presses
  label: string="Value";
  placeholder: string="Enter numeric value";

  viewModel: ViewModel;
  @ViewChild('textboxmatform', { read: ElementRef }) textboxmatform: ElementRef;
  
  constructor(
    private dialogRef: MatDialogRef<ValueEntryFieldComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
     private keyboardService: KeyboardService,
    matDialog: MatDialog) {
      super(errorLogger, matDialog);
  }

    @HostListener('document:keydown.escape')
      onEscapePress() {
        this.cancel();
      }
    ngOnInit(): void {
      if(this.dialogData.title!=undefined){
        this.title = this.dialogData.title;
      }
      if(this.dialogData.symbol!=undefined){
        this.symbol = this.dialogData.symbol;
      }
      if(this.dialogData.isShowHeader!=undefined){
        this.isShowHeader = this.dialogData.isShowHeader;
      }
      if(this.dialogData.isAddNew!=undefined){
        this.isAddNew = this.dialogData.isAddNew;
      }
      if(this.dialogData.label!=undefined){
        this.label = this.dialogData.label;
      }
      if(this.dialogData.placeholder!=undefined){
        this.placeholder = this.dialogData.placeholder;
      }
      if(this.dialogData.isSpinner!=undefined){
        this.isSpinner = this.dialogData.isSpinner;
      }
      if(this.dialogData.isPositiveInteger!=undefined){
        this.isPositiveInteger = this.dialogData.isPositiveInteger;
      }
      this.viewModel = new ViewModel(this.dialogData.items,this.dialogData.sourceItems);
    }

      ngAfterViewInit(): void {
    // Focus out from the textbox after view initialization
   
    this.keyboardService.onKey('Escape', () => {
    this.cancel();
  }, this.destroyRef);
  this.keyboardService.registerEnterToDelete(
    () => this.viewModel.textItems,
    (item) => this.deleteItem(item),
    '#add-input', // 🔥 fallback focus
    this.destroyRef
  );
  //   this.keyboardService.registerArrowNavigation(
  //   this.dialogRoot.nativeElement
  // );
  this.keyboardService.registerGlobalDoubleEnter(() => {
  this.save();
}, this.destroyRef);
  
  }

    save(): void {
      var isvalid=true;
      this.viewModel.textItems.forEach(item=>{
        if(item.text==null || item.text.length==0){
          isvalid=false;
          return;
        }
      });
      if(!isvalid){
        this.displayWarning("No entries can be empty, please enter value.","Warning.");
        return;
      }

      this.dialogRef.close({items: this.viewModel.textItems,eventname:'save'});
    }
  
    cancel(): void {
      this.dialogRef.close({items: this.viewModel.textItems,eventname:'cancel'});
    }
    addItem(): void {
      if(this.viewModel.currentValue==null || this.viewModel.currentValue.length==0){
        this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
        this.enterKeyPressCount++;  // Increment Enter key press counter
        if (this.enterKeyPressCount >= 2) {
          this.save();
        }
        return;
      }
      this.enterKeyPressCount = 0;
      const item = new ColoredTextItem(this.viewModel.currentValue, this.viewModel.currentColor);
      this.viewModel.textItems.push(item);
  
      const maxlength = this.viewModel.colors.length;
      let nextlength = this.viewModel.textItems.length+1;
      var nextIndex=nextlength-1;
      if (nextlength > maxlength) {
        var rem = (nextlength%maxlength);
        if(rem==0){
          nextIndex=maxlength-1;
        }
        else{
          nextIndex=rem-1;
        }
      }
      this.viewModel.currentColor = this.viewModel.colors[nextIndex];
      this.viewModel.currentValue="";
    }
    deleteItem(item: ColoredTextItem): void {
      const index = this.viewModel.textItems.indexOf(item);
      this.viewModel.textItems.splice(index, 1);
      //this.textbox.nativeElement.focus();
      this.reAssignColor();
    }
    reAssignColor(): void {
      let colorIndex = 0;
      this.viewModel.textItems.forEach(item=>{
        item.color=NamedColorList[colorIndex++];
      });
      this.viewModel.currentColor=NamedColorList[colorIndex++];
    }
}
